import React, { useState, Component } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight, CheckCircle, Copy, Check, MessageSquare, Smartphone, Share2, FileText, Sparkles, Zap, Brain, RefreshCw, AlertCircle, UserPlus, History, ArrowUpRight, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TextLandingPage() {
  const [copied, setCopied] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const shareMessage = `✨ Get readable TikToks in seconds! Text any TikTok link to ${phoneNumber} and get an instant transcript. No app needed. Try it: https://scribetok.com/text`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'ScribeTok - Text to Transcript',
          text: shareMessage,
          url: window.location.href
        });
      } catch (error) {
        console.log('Error sharing:', error);
        setShareOpen(!shareOpen);
      }
    } else {
      setShareOpen(!shareOpen);
    }
  };
  const handleCopyShareLink = () => {
    navigator.clipboard.writeText(shareMessage);
    setShareOpen(false);
  };
  return <div className="min-h-screen w-full bg-background flex flex-col items-center justify-center p-4 sm:p-6 overflow-x-hidden" data-id="element-1109">
      <div className="max-w-md w-full mx-auto text-center" data-id="element-1110">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-1111">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-14 w-auto" data-id="element-1112" />
        </div>
        <div className="mb-2" data-id="element-1113">
          <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-1114">
            Text → Read → Share
          </span>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3 animate-slide-down" data-id="element-1115">
          The Reading Mode{' '}
          <span className="text-primary" data-id="element-1116">TikTok Never Gave You</span>
        </h1>
        <p className="text-lg text-muted-foreground mb-8 animate-slide-down" style={{
        animationDelay: '100ms'
      }} data-id="element-1117">
          When you'd rather read than watch. Get the content without the endless
          scrolling.
        </p>
        <Card className="mb-8 animate-scale" style={{
        animationDelay: '200ms'
      }} data-id="element-1118">
          <CardContent className="p-6 flex flex-col items-center" data-id="element-1119">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4" data-id="element-1120">
              <Smartphone size={28} className="text-primary" data-id="element-1121" />
            </div>
            <h2 className="text-xl font-medium mb-2" data-id="element-1122">Text this number</h2>
            <p className="text-sm text-muted-foreground mb-4" data-id="element-1123">
              One text = instant transcript 🪄
            </p>
            <div className="flex items-center gap-2 px-4 py-2 bg-secondary rounded-full cursor-pointer mb-4 hover:bg-secondary/80 transition-colors" onClick={handleCopyNumber} data-id="element-1124">
              <span className="font-medium" data-id="element-1125">{phoneNumber}</span>
              {copied ? <Check size={16} className="text-green-500" data-id="element-1126" /> : <Copy size={16} data-id="element-1127" />}
            </div>
            <div className="text-sm text-muted-foreground mb-4 px-2 py-1 bg-secondary/50 rounded-lg border border-border/50" data-id="element-1128">
              <p className="text-center" data-id="element-1129">
                By texting us, you consent to receive automated reply messages.
                Message & data rates may apply. Reply STOP to unsubscribe.
              </p>
            </div>
            <a href={smsHref} className="block mb-4 relative group mx-auto flex flex-col items-center" data-id="element-1130">
              <div className="absolute -inset-2 bg-primary/5 rounded-2xl scale-0 group-hover:scale-100 transition-transform" data-id="element-1131"></div>
              <img src="https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=sms:+17744727423" alt="SMS QR Code" className="rounded-lg shadow-md relative z-10" width={180} height={180} data-id="element-1132" />
              <p className="text-sm text-muted-foreground mt-2 relative z-10 text-center" data-id="element-1133">
                Scan to open SMS on your phone
              </p>
            </a>
            <a href={smsHref} className="w-full" data-id="element-1134">
              <Button size="lg" className="w-full group" data-id="element-1135">
                <MessageSquare size={16} className="mr-2 group-hover:animate-bounce" data-id="element-1136" />
                Text Now
              </Button>
            </a>
          </CardContent>
        </Card>
        <div className="space-y-6 mb-10 animate-fade-in" style={{
        animationDelay: '300ms'
      }} data-id="element-1137">
          <div className="text-left" data-id="element-1138">
            <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-1139">
              <Zap size={18} className="text-primary mr-2" data-id="element-1140" />
              How It Works
            </h3>
            <ol className="space-y-4" data-id="element-1141">
              <li className="flex items-start gap-3" data-id="element-1142">
                <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1143">
                  1
                </div>
                <div data-id="element-1144">
                  <p className="font-medium" data-id="element-1145">Text any TikTok link</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1146">
                    Send a TikTok URL to {phoneNumber} to start.{' '}
                    <span className="text-primary font-medium" data-id="element-1147">
                      No account needed!
                    </span>
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-1148">
                <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1149">
                  2
                </div>
                <div data-id="element-1150">
                  <p className="font-medium" data-id="element-1151">Get your transcript</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1152">
                    Readable content, instantly delivered
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-1153">
                <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1154">
                  3
                </div>
                <div data-id="element-1155">
                  <p className="font-medium" data-id="element-1156">Remix and share</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1157">
                    Quote, tweet, blog, or save for later
                  </p>
                </div>
              </li>
            </ol>
          </div>
          {/* Phone-First Experience Section */}
          <div className="text-left" data-id="element-1158">
            <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-1159">
              <Smartphone size={18} className="text-primary mr-2" data-id="element-1160" />
              Phone-First Experience
            </h3>
            <div className="space-y-3" data-id="element-1161">
              <div className="flex items-start gap-2" data-id="element-1162">
                <History size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1163" />
                <div data-id="element-1164">
                  <p className="font-medium" data-id="element-1165">History Preserved</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1166">
                    All transcripts are saved under your phone number - even
                    before creating an account
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1167">
                <UserPlus size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1168" />
                <div data-id="element-1169">
                  <p className="font-medium" data-id="element-1170">Create Account When Ready</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1171">
                    Text <span className="font-medium" data-id="element-1172">/register</span> anytime
                    to create an account with all history intact
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1173">
                <ArrowUpRight size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1174" />
                <div data-id="element-1175">
                  <p className="font-medium" data-id="element-1176">Seamless Web Transition</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1177">
                    Switch between SMS and web without losing any data
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left" data-id="element-1178">
            <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-1179">
              <Sparkles size={18} className="text-primary mr-2" data-id="element-1180" />
              Magic Commands
            </h3>
            <div className="space-y-3" data-id="element-1181">
              <div className="flex items-start gap-2" data-id="element-1182">
                <FileText size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1183" />
                <div data-id="element-1184">
                  <p className="font-medium" data-id="element-1185">/vault</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1186">
                    Access your 5 most recent transcripts
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1187">
                <Brain size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1188" />
                <div data-id="element-1189">
                  <p className="font-medium" data-id="element-1190">/summary</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1191">
                    Get the key points in seconds - perfect for information
                    overload
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1192">
                <UserPlus size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1193" />
                <div data-id="element-1194">
                  <p className="font-medium" data-id="element-1195">/register</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1196">
                    Create an account that preserves all your transcript history
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1197">
                <RefreshCw size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1198" />
                <div data-id="element-1199">
                  <p className="font-medium" data-id="element-1200">/help</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1201">
                    Discover all available commands
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left bg-secondary/30 p-4 rounded-lg border border-border" data-id="element-1202">
            <h3 className="text-lg font-medium mb-2 flex items-center" data-id="element-1203">
              <AlertCircle size={18} className="text-primary mr-2" data-id="element-1204" />
              SMS Consent
            </h3>
            <p className="text-sm text-muted-foreground" data-id="element-1205">
              By texting our number, you agree to receive automated reply
              messages. Standard message rates may apply. Reply STOP to opt out
              at any time.
              <Link to="/text/compliance" className="text-primary hover:underline ml-1" data-id="element-1206">
                View full terms
              </Link>
            </p>
          </div>
        </div>
        {/* User Journey Visualization */}
        <div className="mb-10 animate-fade-in" style={{
        animationDelay: '400ms'
      }} data-id="element-1207">
          <h3 className="text-lg font-medium mb-4" data-id="element-1208">Your Seamless Journey</h3>
          <div className="bg-secondary/30 rounded-lg p-4 border border-border" data-id="element-1209">
            <div className="flex flex-col space-y-4" data-id="element-1210">
              <div className="flex items-center" data-id="element-1211">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-1212">
                  <MessageSquare size={16} className="text-primary" data-id="element-1213" />
                </div>
                <div className="flex-1" data-id="element-1214">
                  <p className="font-medium" data-id="element-1215">First Text</p>
                  <p className="text-xs text-muted-foreground" data-id="element-1216">
                    Get instant value with no account
                  </p>
                </div>
              </div>
              <div className="w-0.5 h-4 bg-primary/30 ml-5" data-id="element-1217"></div>
              <div className="flex items-center" data-id="element-1218">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-1219">
                  <History size={16} className="text-primary" data-id="element-1220" />
                </div>
                <div className="flex-1" data-id="element-1221">
                  <p className="font-medium" data-id="element-1222">Build History</p>
                  <p className="text-xs text-muted-foreground" data-id="element-1223">
                    All transcripts saved to your phone number
                  </p>
                </div>
              </div>
              <div className="w-0.5 h-4 bg-primary/30 ml-5" data-id="element-1224"></div>
              <div className="flex items-center" data-id="element-1225">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-1226">
                  <UserPlus size={16} className="text-primary" data-id="element-1227" />
                </div>
                <div className="flex-1" data-id="element-1228">
                  <p className="font-medium" data-id="element-1229">Create Account (When Ready)</p>
                  <p className="text-xs text-muted-foreground" data-id="element-1230">
                    Text /register to preserve all history
                  </p>
                </div>
              </div>
              <div className="w-0.5 h-4 bg-primary/30 ml-5" data-id="element-1231"></div>
              <div className="flex items-center" data-id="element-1232">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-1233">
                  <ArrowUpRight size={16} className="text-primary" data-id="element-1234" />
                </div>
                <div className="flex-1" data-id="element-1235">
                  <p className="font-medium" data-id="element-1236">Seamless Web Access</p>
                  <p className="text-xs text-muted-foreground" data-id="element-1237">
                    Switch between SMS and web anytime
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-border pt-6 animate-fade-in" style={{
        animationDelay: '400ms'
      }} data-id="element-1238">
          <div className="flex flex-col items-center mb-6" data-id="element-1239">
            <h3 className="text-lg font-medium mb-2" data-id="element-1240">Share the Magic</h3>
            <p className="text-sm text-muted-foreground mb-4" data-id="element-1241">
              Help your friends skip the endless scrolling 🧠✨
            </p>
            <div className="flex gap-3" data-id="element-1242">
              <Button variant="outline" onClick={handleShare} className="relative" data-id="element-1243">
                <Share2 size={16} className="mr-2" data-id="element-1244" />
                Share ScribeTok
                {shareOpen && <div className="absolute top-full mt-2 right-0 bg-card shadow-lg rounded-lg p-3 z-10 w-60 text-left" data-id="element-1245">
                    <Button variant="ghost" size="sm" className="w-full justify-start mb-2" onClick={handleCopyShareLink} data-id="element-1246">
                      <Copy size={14} className="mr-2" data-id="element-1247" />
                      Copy message
                    </Button>
                    <a href={`https://wa.me/?text=${encodeURIComponent(shareMessage)}`} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-1248">
                      <Button variant="ghost" size="sm" className="w-full justify-start mb-2" data-id="element-1249">
                        <span className="mr-2" data-id="element-1250">📱</span>
                        WhatsApp
                      </Button>
                    </a>
                    <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-1251">
                      <Button variant="ghost" size="sm" className="w-full justify-start" data-id="element-1252">
                        <span className="mr-2" data-id="element-1253">🐦</span>
                        Twitter
                      </Button>
                    </a>
                  </div>}
              </Button>
              <Link to="/features" data-id="element-1254">
                <Button variant="outline" data-id="element-1255">
                  Creator Features
                  <Star size={16} className="ml-2" data-id="element-1256" />
                </Button>
              </Link>
              <Link to="/app" data-id="element-1257">
                <Button variant="outline" data-id="element-1258">
                  Web App
                  <ArrowRight size={16} className="ml-2" data-id="element-1259" />
                </Button>
              </Link>
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-muted-foreground text-sm mb-6" data-id="element-1260">
            <div className="flex items-center gap-2" data-id="element-1261">
              <CheckCircle size={14} className="text-success" data-id="element-1262" />
              <span data-id="element-1263">10,000+ Videos Transcribed Daily</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1264">
              <CheckCircle size={14} className="text-success" data-id="element-1265" />
              <span data-id="element-1266">Free for Everyone</span>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mb-2" data-id="element-1267">
            Your privacy, your words. ScribeTok never sells your data. 🔒
          </p>
          <p className="text-xs text-muted-foreground border-t border-border/50 pt-3 mt-3" data-id="element-1268">
            ScribeTok is a user-initiated SMS service. We do not send
            promotional messages. You can opt out at any time by replying STOP.
            Msg & data rates may apply.
          </p>
        </div>
        <div className="mt-12 max-w-lg mx-auto" data-id="element-1269">
          <h3 className="text-xl font-medium mb-4" data-id="element-1270">Example SMS Conversation</h3>
          <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left" data-id="element-1271">
            <div className="space-y-4" data-id="element-1272">
              <div className="flex justify-end" data-id="element-1273">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1274">
                  https://www.tiktok.com/@username/video/1234567890
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1275">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1276">
                  <p className="flex items-start gap-2" data-id="element-1277">
                    <span className="text-xl" data-id="element-1278">🎬</span>
                    <span data-id="element-1279">
                      Thanks for using ScribeTok! You'll receive a transcript
                      shortly. Reply HELP for support or STOP to opt out.
                    </span>
                  </p>
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1280">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1281">
                  <p className="flex items-start gap-2" data-id="element-1282">
                    <span className="text-xl" data-id="element-1283">⏳</span>
                    <span data-id="element-1284">Got your link! Transcribing now...</span>
                  </p>
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1285">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-1286">
                  <p className="flex items-start gap-2" data-id="element-1287">
                    <span className="text-xl flex-shrink-0" data-id="element-1288">✅</span>
                    <span data-id="element-1289">Transcript ready!</span>
                  </p>
                  <p className="mt-2 ml-7" data-id="element-1290">
                    "Hey everyone, today I'm going to show you three
                    productivity hacks that changed my life..."
                  </p>
                  <p className="text-xs mt-2 text-primary font-medium ml-7" data-id="element-1291">
                    share.scribetok.com/v/b70c860b-d7dc-4570-ae26-1235c94ee654
                  </p>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-1292">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1293">
                  /summary
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1294">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1295">
                  <p className="flex items-start gap-2" data-id="element-1296">
                    <span className="text-xl" data-id="element-1297">📝</span>
                    <span className="font-medium" data-id="element-1298">Summary:</span>
                  </p>
                  <p className="mt-2 ml-7" data-id="element-1299">
                    Three productivity hacks: time blocking, two-minute rule for
                    small tasks, and digital detox every evening.
                  </p>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-1300">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1301">
                  /register
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1302">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1303">
                  <p className="flex items-start gap-2" data-id="element-1304">
                    <span className="text-xl" data-id="element-1305">👤</span>
                    <span className="font-medium" data-id="element-1306">
                      Let's create your account!
                    </span>
                  </p>
                  <p className="mt-2 ml-7" data-id="element-1307">
                    Enter your email to create an account and access all your
                    transcripts on the web.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}